import { render, staticRenderFns } from "./serviceConsultingManage.vue?vue&type=template&id=5efc9666&scoped=true"
import script from "./serviceConsultingManage.vue?vue&type=script&lang=js"
export * from "./serviceConsultingManage.vue?vue&type=script&lang=js"
import style0 from "./serviceConsultingManage.vue?vue&type=style&index=0&id=5efc9666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc9666",
  null
  
)

export default component.exports